import { DisciplineState } from "@reducers/types/HRM/discipline-state";
import {
  DELETE_DISCIPLINE_HISTORY,
  GET_DISCIPLINE_HISTORY,
  CREATE_DISCIPLINE,
  UPDATE_DISCIPLINE,
} from "@actions/HRM/employee/types";
import { DisciplineActions } from "@actions/HRM/employee/discipline-actions";

import { DisciplineType } from "@type/HRM/discipline";

import {
  getFailedState,
  getRequestingState,
  getSuccessState,
  getInitialState,
} from "@utils/store";

const initialState: DisciplineState = {
  ...getInitialState(),
};

const resetStates = {
  deleteDisciplineSuccess: false,
  deleteDisciplineFailed: false,
  createDisciplineSuccess: false,
  createDisciplineFailed: false,
  updateDisciplineSuccess: false,
  updateDisciplineFailed: false,
};

const disciplineReducer = (
  state = initialState,
  action: DisciplineActions,
): DisciplineState => {
  switch (action.type) {
    case GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: null,
          getDisciplineRequestOngoing: true,
          getDisciplineSuccess: false,
          getDisciplineFailed: false,
        }),
      };
    }

    case GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_SUCCESS: {
      const { payload } = action as any;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getDisciplineRequestOngoing: false,
          getDisciplineSuccess: true,
          getDisciplineFailed: false,
        }),
      };
    }
    case GET_DISCIPLINE_HISTORY.GET_DISCIPLINE_HISTORY_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          getDisciplineRequestOngoing: false,
          getDisciplineSuccess: false,
          getDisciplineFailed: true,
        }),
      };
    }

    // Delete
    case DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteDisciplineRequestOngoing: true,
          deleteDisciplineSuccess: false,
          deleteDisciplineFailed: false,
        }),
      };
    }

    case DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_SUCCESS: {
      const { payload } = action as any;

      const updatedData =
        state && state.data
          ? state.data.filter((item: any) => item.id !== payload?.data)
          : [];

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteDisciplineRequestOngoing: false,
          deleteDisciplineSuccess: true,
          deleteDisciplineFailed: false,
        }),
      };
    }

    case DELETE_DISCIPLINE_HISTORY.DELETE_DISCIPLINE_TABLE_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          data: null,
          deleteDisciplineRequestOngoing: false,
          deleteDisciplineSuccess: false,
          deleteDisciplineFailed: true,
        }),
      };
    }

    // Create
    case CREATE_DISCIPLINE.CREATE_DISCIPLINE_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          createDisciplineRequestOngoing: true,
          createDisciplineSuccess: false,
          createDisciplineFailed: false,
        }),
      };
    }

    case CREATE_DISCIPLINE.CREATE_DISCIPLINE_SUCCESS: {
      const { payload } = action as any;
      const previousData = state.data as DisciplineType[];
      const updatedData = [...previousData, payload.data];

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          createDisciplineRequestOngoing: false,
          createDisciplineSuccess: true,
          createDisciplineFailed: false,
        }),
      };
    }

    case CREATE_DISCIPLINE.CREATE_DISCIPLINE_FAILED: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          createDisciplineRequestOngoing: false,
          createDisciplineSuccess: false,
          createDisciplineFailed: true,
        }),
      };
    }

    // Update
    case UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateDisciplineRequestOngoing: true,
          updateDisciplineSuccess: false,
          updateDisciplineFailed: false,
        }),
      };
    }

    case UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_SUCCESS: {
      const { payload } = action as any;
      const previousData = state.data as DisciplineType[];
      const updatedData = previousData.map((item: any) =>
        item.id === payload.data.id ? payload.data : item,
      );

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateDisciplineRequestOngoing: false,
          updateDisciplineSuccess: true,
          updateDisciplineFailed: false,
        }),
      };
    }

    case UPDATE_DISCIPLINE.UPDATE_DISCIPLINE_FAILED: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateDisciplineRequestOngoing: false,
          updateDisciplineSuccess: false,
          updateDisciplineFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default disciplineReducer;
